'use client'
// HEADLESS ERRORS
const ACTIVE_SESSION = 'session_active';
const ERROR_SENDING_CODE = 'error_sending_code';
const ERROR_PROCESSING_REVEAL_REQUEST = 'error_processing_reveal_request';
const INVALID_REQUEST = 'invalid_request';
const INVALID_WALLET_DATA = 'invalid_wallet';
const SECURE_ENCLAVE_PROVIDER_NOT_ENABLED = 'secure_enclave_provider_not_enabled';
const USER_NOT_LOGGED_IN = 'user_not_logged_in';
const CODE_SENT = 'code_sent';
const SESSION_CREATED = 'session_created';
const SESSION_RESTORED = 'session_restored';
const ACCESS_BLOCKED_ERROR_CODE = 451;

export { ACCESS_BLOCKED_ERROR_CODE, ACTIVE_SESSION, CODE_SENT, ERROR_PROCESSING_REVEAL_REQUEST, ERROR_SENDING_CODE, INVALID_REQUEST, INVALID_WALLET_DATA, SECURE_ENCLAVE_PROVIDER_NOT_ENABLED, SESSION_CREATED, SESSION_RESTORED, USER_NOT_LOGGED_IN };
